import { render, staticRenderFns } from "./Budget_5_42.vue?vue&type=template&id=2b76bb14&scoped=true&"
import script from "./Budget_5_42.vue?vue&type=script&lang=js&"
export * from "./Budget_5_42.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b76bb14",
  null
  
)

export default component.exports